import { useNavigate } from "react-router-dom";
import 'bootstrap/dist/css/bootstrap.min.css';
// import { Container, Row, Col, Table } from 'react-bootstrap';
import React, { useState, useEffect } from "react";
import ArrowBackIosNew from "@mui/icons-material/ArrowBackIosNew";
import "./pickUpDetails.css";
import { authKey, GET_CONSIGNMENT_DETAILS_BY_NUMBER, CONSIGNMENT_PICK_UP_SAVE, UPLOAD_DCUMENT, DOWNLOAD_DOCUMENT } from '../../../common/URLs';

import { useLocation } from "react-router-dom";
import { ConfirmPopover } from '../../../preregcamps/confirmPopover/confirmPopover';
import { ErrorPopover } from '../../../common/ErrorPopover/errorPopover';
import { confirmAlert } from 'react-confirm-alert';
import { loaderService } from "../../../common/custom-loader/loader-service";
import { DialogContent, Dialog, DialogActions, Button, CardContent, Box, Divider, FormHelperText, TextField, InputLabel, Select, MenuItem } from '@mui/material';
import { getLocalStorageItem } from "../../../common/localStorageUtils";
import { allowedFileTypes, FILE_NAME_VALIDATION_ERROR, NO_DATA_AVAILABLE, PROD } from "../../../common/constants";
import { toast } from 'react-toastify';
import { Fab, Typography, Container, Card, Grid } from '@mui/material';
import { KeyboardArrowLeftRounded } from '@mui/icons-material';
import { fileNameValidation, typeNumberValid } from "../../../common/commonValidations";
import { QuickSearchToolbar } from '../../../payment/common/commonFunctions';
import { DataGrid } from "@mui/x-data-grid";
import Radio from '@mui/material/Radio';
import RadioGroup from '@mui/material/RadioGroup';
import FormControlLabel from '@mui/material/FormControlLabel';
import FormControl from '@mui/material/FormControl';
import FormLabel from '@mui/material/FormLabel';
import FormHelpText from "rsuite/esm/FormHelpText";
import { ConfirmationPopover } from "../../../common/commonPopovers/confirmationPopover";
import { handleNumberFieldFocus } from "../../../common/commonFunction";
import apiClient from "../../../axios";


function PickUpDetails() {

  const { state } = useLocation();
  const navigate = useNavigate();

  const consignmentsource = state?.consignmentdetails?.consignmentSourceDetails;
  const [selectedTransitFile, setSelectedTransitFile] = useState();
  const [selectedNocFile, setSelectedNocFile] = useState();
  const [nocUploadDOc, setNocUploadDOc] = useState();
  const [transitPassUploadDOc, setTransitPassUploadDOc] = useState();
  
  const [showGrid, setShowGrid] = useState(false);
  const [pickupDetailsFormData, setPickupDetailsFormData] = useState()
  const [pickupDetailsSave, setPickupDetailsSave] = useState();
  const [pickupdetailsdata, setPickupdetailsdata] = useState();
  const [pickupdetailsSourcedata, setPickupdetailsSourcedata] = useState([]);
  const [pickupdetailsBundledata, setPickupdetailsBundledata] = useState();
  const [hideButtons, setHideButtons] = useState(false);
  const [consNo, setConsNo] = useState();
  const [documentUploadDetails, setDocumentUploadDetails] = useState();
  const [documentUploadDetailsForest, setDocumentUploadDetailsForest] = useState();
  const [lotDetails, setLotDetails] = useState(state?.growerItem?.consignmentPickupRbCbs);
  const [totalLotDetailsWeight, setTotalLotDetailsWeight] = useState(Number(state?.growerItem?.consignmentPickupRbCbs?.reduce((accum, item) => Number(accum) + Number(item.rbCbWeight), 0)));
  const [avgMoistureLotDetails, setAvgLotDetailsMoisture] = useState(Number(state?.growerItem?.consignmentPickupRbCbs?.reduce((accum, item) => Number(accum) + Number(item.avgMoisture), 0) / lotDetails.length));
  const [lotDetailsArrNew, setLotDetailsArrNew] = useState([]);
  const [templotDetailsArr, setTempLotDetailsArr] = useState([]);
  const [completeLoading, setCompleteLoading] = useState();
  const [logModalOpen, setLogModalOpen] = useState(false);
  const handleLogModalOpen = () => setLogModalOpen(true);
  const [logModalOpen1, setLogModalOpen1] = useState(false);
  const handleLogModalOpen1 = () => setLogModalOpen1(true);
  const handleLogModalClose1 = () => setLogModalOpen1(false);

  const [confirmOpen, setConfirmOpen] = useState(false);
  const handleConfirmOpen = () => setConfirmOpen(true);
  const handleConfirmClose = () => setConfirmOpen(false);

  const [confirmOpen2, setConfirmOpen2] = useState(false);
  const handleConfirmOpen2 = () => setConfirmOpen2(true);
  const handleConfirmClose2 = () => setConfirmOpen2(false);

  const RBfileDownload = state?.growerItem;

  const [pickupUpdatedDetails, setPickupUpdatedDetails] = useState({
    // "isHitInspectionChecklist": state?.growerItem?.isHitInspectionChecklist,
    "isProperLashing": state?.growerItem?.isProperLashing,
    "isPayloadWithinCapacity": state?.growerItem?.isPayloadWithinCapacity,
    "isPayloadLengthExceedLimit": state?.growerItem?.isPayloadLengthExceedLimit,
    "isPayloadHeightExceedLimit": state?.growerItem?.isPayloadHeightExceedLimit,
    "odometerReading": state?.growerItem?.odometerReading,
    "nocFileId": state?.growerItem?.nocFileId,
    "nocFileName": state?.growerItem?.nocFileName,
    "transitPassFileId": state?.growerItem?.transitPassFileId,
    "transitFileName": state?.growerItem?.transitFileName,
    "containerName": state?.growerItem?.containerName,
    "acknowledgementId": state?.growerItem?.acknowledgementId
  })
  const [totalGrower, setTotalGrower] = useState([]);

  const [lotDetailsData, setLotDetailsData] = useState({
    "consignmentSourceDetailId": state?.growerItem?.id,
    "rbCbWeight": "",
    "avgMoisture": "",
    "speciesType": "",
    "noOfPoles": "",
    "barcodeNo": "",
    "bundleId": null,
    "isACtive": 1,

  })

  const [errorMessage, setErrorMessage] = useState({
    rbCbWeightError: "",
    avgMoistureError: "",
    barcodeNoError: "",
    speciesTypeError: "",
    noOfPolesError: "",
    isHitInspectionChecklistError: "",
    isProperLashingError: "",
    isPayloadWithinCapacityError: "",
    isPayloadLengthExceedLimitError: "",
    isPayloadHeightExceedLimitError: "",
    odometerReadingError: '',
    lotDetailsError: "",

  });

  
  const uploadNocDoc = (e, type) => {
    if (allowedFileTypes.indexOf(e.target.files[0].type) < 0) {
      return;
    }
    if (e.target.files[0].name.split('.').length > 2) {
      setErrorMessage({
        ...errorMessage,
        nocFileIdError: "Double extension file detected",
      });
      return;
    }
    if (e.target.files[0].size >= 5000000) {
      setErrorMessage({
        ...errorMessage,
        nocFileIdError: "The file should be less than 5MB",
      });
    }
    else if (fileNameValidation(e.target.files[0].name)) {
      setErrorMessage({
        ...errorMessage,
        nocFileIdError: FILE_NAME_VALIDATION_ERROR,
      });
    } else {
      setSelectedNocFile(e.target.files[0]);
      setPickupUpdatedDetails({ ...pickupUpdatedDetails, nocFileId: nocUploadDOc ? nocUploadDOc?.blobResponse?.blobFileName : consignmentsource?.[0]?.nocFileId, nocFileName: nocUploadDOc ? nocUploadDOc?.blobResponse?.fileName : consignmentsource?.[0]?.nocFileName, containerName: "pit" })
      setErrorMessage({ ...errorMessage, nocFileIdError: " " });
    }
  };

  useEffect(() => {
    if (selectedTransitFile) {
      getUploadTransitPassFileDetails();
    }
  }, [selectedTransitFile]);

  useEffect(() => {
    if (selectedNocFile) {
      getUploadNocFileDetails();
    }
  }, [selectedNocFile]);

  function getUploadNocFileDetails() {
    // loaderService.showLoader();
    const formData = new FormData();
    formData.append("file", selectedNocFile);
    formData.append("fileName", selectedNocFile.name);
    formData.append("containerName", "pit");
    apiClient
      .post(UPLOAD_DCUMENT, formData, {
        headers: {
          AuthKey: authKey,
        },
      })
      .then((response) => {
        setNocUploadDOc(response.data);
        // loaderService.hideLoader();
      })

      .catch(function (error) {
        console.log(error);
        // loaderService.hideLoader();
        toast.error(error.message);
      });
  }
  function getUploadTransitPassFileDetails() {
    // loaderService.showLoader();
    const formData = new FormData();
    formData.append("file", selectedTransitFile);
    formData.append("fileName", selectedTransitFile.name);
    formData.append("containerName", "pit");
    apiClient
      .post(UPLOAD_DCUMENT, formData, {
        headers: {
          AuthKey: authKey,
        },
      })
      .then((response) => {
        setTransitPassUploadDOc(response.data);
        // loaderService.hideLoader();
      })

      .catch(function (error) {
        console.log(error);
        // loaderService.hideLoader();
        toast.error(error.message);
      });
  }

  const viewAndDownloadDocument = (e, fileName, finalfileName, containerName) => {
    e.preventDefault();
    viewdownloadDocument(consignmentsource?.[0]?.nocFileId, consignmentsource?.[0]?.nocFileName, consignmentsource?.[0]?.containerName)
  }
  const viewAndDownloadDocumentForTransit = (e, fileName, finalfileName, containerName) => {
    e.preventDefault();
    viewdownloadDocument(consignmentsource?.[0]?.transitPassFileId, consignmentsource?.[0]?.transitFileName, consignmentsource?.[0]?.containerName)
  }

  const viewdownloadDocument = (documentBlobName, finalfileName, type) => {
    loaderService.showLoader();
    return fetch(DOWNLOAD_DOCUMENT,
      {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          AuthKey: authKey,
        },
        body: JSON.stringify({
          "fileName": documentBlobName,
          "containerName": "pit",
          "file": ""
        })
      })
      .then((response) => response.blob()
      )
      .then((blob) => {
        if (type === "View") {
          const fileName = finalfileName
          const splittedName = fileName.split('.')
          const fileExtension = splittedName[splittedName.length - 1];
          let fileType;
          switch (fileExtension) {
            case 'pdf':
              fileType = 'application/pdf';
              break;
            case 'png':
              fileType = 'image/png';
              break;
            case 'jpg':
              fileType = 'image/jpeg';
              break;
            case 'jpeg':
              fileType = 'image/jpeg';
              break;
            default:
              fileType = 'application/octet-stream';
          }
          const url = window.URL.createObjectURL(new Blob([blob], { type: fileType }));
          const newWindow = window.open(url, '_blank');
          newWindow.focus();
        }
        else {
          const a = document.createElement("a");
          a.style.display = "none";
          document.body.appendChild(a);
          const url = window.URL.createObjectURL(blob);
          a.href = url;
          a.download = finalfileName;
          a.click();
          window.URL.revokeObjectURL(url);
        }
        loaderService.hideLoader();
      })
      .catch(function (error) {
        console.log(error);
        loaderService.hideLoader();
      });
  }
  
  const uploadTransitPassDoc = (e, type) => {
    if (allowedFileTypes.indexOf(e.target.files[0].type) < 0) {
      return;
    }
    if (e.target.files[0].name.split('.').length > 2) {
      setErrorMessage({
        ...errorMessage,
        transitPassFileIdError: "Double extension file detected",
      });
      return;
    }
    if (e.target.files[0].size >= 5000000) {
      setErrorMessage({
        ...errorMessage,
        transitPassFileIdError: "The file should be less than 5MB",
      });
    }
    else if (fileNameValidation(e.target.files[0].name)) {
      setErrorMessage({
        ...errorMessage,
        transitPassFileIdError: FILE_NAME_VALIDATION_ERROR,
      })
    }
    else {
      setSelectedTransitFile(e.target.files[0]);
      setPickupUpdatedDetails({ ...pickupUpdatedDetails, transitPassFileId: transitPassUploadDOc ? transitPassUploadDOc?.blobResponse?.blobFileName : consignmentsource?.[0]?.transitPassFileId, transitFileName: transitPassUploadDOc ? transitPassUploadDOc?.blobResponse?.fileName : consignmentsource?.[0]?.transitFileName, containerName: "pit" })
      setErrorMessage({ ...errorMessage, transitPassFileIdError: "" });
    }
  };

  const handleChange = (e) => {
    const limit = 6;
    if (e.target.name === "odometerReading") {
      setPickupUpdatedDetails({ ...pickupUpdatedDetails, [e.target.name]: e.target.value.slice(0, limit) })
    }
    // console.log(pickupUpdatedDetails.odometerReading)
    setLotDetailsData({

      ...lotDetailsData,

      [e.target.name]: e.target.value,

    });

    if (e.target.value.length > e.target.maxLength)
      e.target.value = e.target.value.slice(0, e.target.maxLength);

    if (e.target.name === "rbCbWeight") {
      setErrorMessage({ ...errorMessage, rbCbWeightError: "" });
    }
    if (e.target.name === "avgMoisture") {
      setErrorMessage({ ...errorMessage, avgMoistureError: "" });
    }
    if (e.target.name === "barcodeNoError") {
      setErrorMessage({ ...errorMessage, barcodeNoError: "" });
    }
    if (e.target.name === "speciesType") {
      setErrorMessage({ ...errorMessage, speciesTypeError: "" });
    }
    if (e.target.name === "noOfPoles") {
      setErrorMessage({ ...errorMessage, noOfPolesError: "" });
    }
    if (e.target.name === "odometerReading") {
      setErrorMessage({ ...errorMessage, odometerReadingError: "" });
    }

  }
  // console.log("invoice",invoiceNo)
  // const onAddBundle = (e) => {
  //     e.preventDefault();
  //     setShowGrid(true);
  //     const tempArr = [...lotDetailsData]
  //     getPickupdetailsdataBundle();
  // }

  const onAddBundle = (e) => {
    e.preventDefault();
    setErrorMessage({ ...errorMessage, lotDetailsError: "" });
    if ((lotDetailsData.speciesType) && (lotDetailsData.avgMoisture) && (lotDetailsData.rbCbWeight) && (lotDetailsData.barcodeNo) && (lotDetailsData.noOfPoles)) {
      // setShowGrid(true);
      const tempArr = [...lotDetails]
      const tempArrNew = [...lotDetailsArrNew]
      //speciesDetailsArr.find(item => { return item.species === speciesDetails.species }) ? setErrorMessage({ ...errorMessage, sameSpeciesError: "Please add different species" }) :
      tempArr.push({
        ...lotDetailsData,
      });
      tempArrNew.push({ ...lotDetailsData })
      setLotDetails(tempArr);
      setLotDetailsArrNew(tempArrNew);
      setTotalLotDetailsWeight(Number(tempArr?.reduce((accum, item) => Number(accum) + Number(item.rbCbWeight), 0)))
      setAvgLotDetailsMoisture(Number(tempArr?.reduce((accum, item) => Number(accum) + Number(item.avgMoisture), 0 / lotDetails.length)))
      setLotDetailsData({
        "consignmentSourceDetailId": state?.growerItem?.id,
        "rbCbWeight": "",
        "avgMoisture": "",
        "speciesType": "",
        "noOfPoles": "",
        "barcodeNo": "",
        "bundleId": null,
        "isACtive": 1

      });
      document.getElementById("myForm").reset();
    }
    else {
      if (!lotDetailsData?.barcodeNo) {
        setErrorMessage({ ...errorMessage, barcodeNoError: "Please Enter Barcode" });
      }
      if (!lotDetailsData?.noOfPoles) {
        setErrorMessage({ ...errorMessage, noOfPolesError: "Please Enter No of Poles" });
      }
      if (!lotDetailsData?.avgMoisture) {
        setErrorMessage({ ...errorMessage, avgMoistureError: "Please Enter Moisture" });
      }
      if (!lotDetailsData?.rbCbWeight) {
        setErrorMessage({ ...errorMessage, rbCbWeightError: "Please Enter Weight" });
      }
      if (!lotDetailsData?.speciesType) {
        setErrorMessage({ ...errorMessage, speciesTypeError: "Please Select Species" });
      }
    }
  }

  useEffect(() => {
    if (consNo) {
      getPickupdetailsdataBundle();
    }
  }, [consNo]);
  useEffect(() => {
    setConsNo(state?.data?.consignmentNo);
  }, []);

  const getPickupdetailsdataBundle = () => {
    loaderService.showLoader()
    apiClient
      .post(GET_CONSIGNMENT_DETAILS_BY_NUMBER,
        {
          "consignmentNumber": consNo,
        },
        {
          headers: {
            Authorization: 'Bearer ' + getLocalStorageItem('id_token'),
          }
        }, null
      )
      .then((response) => {
        // console.log("1",response);
        setLotDetails(response.data.consignmentSourceDetails[0].consignmentPickupRbCbs);
        setHideButtons(response.data.consignmentSourceDetails[0].invoiceNo != null);
        setTotalGrower(response.data.consignmentSourceDetails);
        loaderService.hideLoader()
      })
      .catch(function (error) {
        console.log(error);
        loaderService.hideLoader()
        toast.error(error.message);
      });
  }

  const onConfirmSave = (e) => {
    handleConfirmClose();
    pickupSave(false);
    // onSaveLotDetails(e);
  }

  const onSaveButtonClick = (e) => {
    handleConfirmOpen();
  }

  const onConfirmComplete = (e) => {
    handleConfirmClose2();
    pickupSave(true);
    // onLoadingDoneLotDetails(e);
  }

  const onCompleteClick = (e) => {
    handleConfirmOpen2();
  }

  const onSaveLotDetails = (e) => {
    e.preventDefault();
    if (lotDetails.length > 0) {
      onSaveButtonClick();
    }
    else {
      setErrorMessage({ ...errorMessage, lotDetailsError: "Please Add atleast one Lot" });
    }
  }


  const onLoadingDoneLotDetails = (e) => {
    e.preventDefault();
    if (lotDetails.length > 0) {
      onCompleteClick();
    }
    else {
      setErrorMessage({ ...errorMessage, lotDetailsError: "Please Add atleast one Lot" });
    }
  }

  const pickupSave = (loadingDone) => {
    const totalWeightOfGrowers = Number(state?.consignmentdetails?.consignmentSourceDetails?.reduce((accum, item) => Number(accum) + Number(item.totalWeight), 0));
    const totalMoistureOfGrowers = Number(state?.consignmentdetails?.consignmentSourceDetails?.reduce((accum, item) => Number(accum) + Number(item.totalMoisture), 0) / state?.consignmentdetails?.consignmentSourceDetails?.length);
    // const totalLotDetailsWeight = Number(lotDetails?.reduce((accum,item) => Number(accum) + Number(item.rbCbWeight), 0));
    // const totalLotDetailsMoisture = Number(lotDetails?.reduce((accum,item) => Number(accum) + Number(item.avgMoisture), 0));
    // totalLotDetailsWeight = Number(state?.growerItem?.consignmentPickupRbCbs?.reduce((accum,item) => Number(accum) + Number(item.rbCbWeight), 0));
    // avgMoistureLotDetails = Number(state?.growerItem?.consignmentPickupRbCbs?.reduce((accum,item) => Number(accum) + Number(item.avgMoisture), 0) / lotDetails.length)


    // console.log("lotweight",totalLotDetailsMoisture);
    apiClient
      .post(CONSIGNMENT_PICK_UP_SAVE,
        {

          "id": state?.consignmentdetails?.id,

          "consignmentNo": state?.consignmentdetails?.consignmentNo,

          "isLoadingDone": loadingDone,

          "totalWeight": totalWeightOfGrowers,

          // "totalMoisture": totalLotDetailsMoisture,
          "totalMoisture": totalMoistureOfGrowers,

          "consignmentSourceDetails": [

            {

              "id": state?.growerItem?.id,

              "consignmentId": state?.consignmentdetails?.id,

              "weeklyScheduleNumber": state?.growerItem?.weeklyScheduleNumber,

              "scheduleLineNumber": state?.growerItem?.scheduleLineNumber,

              "consignmentStatus": state?.growerItem?.consignmentStatus,

              // "consignmentPickupTimestamp": "2022-12-29T13:59:08.787Z",

              "weightToBeLifted": state?.growerItem?.weightToBeLifted,

              "sourceType": state?.growerItem?.sourceType,

              "sourceStakeholderUrn": state?.growerItem?.sourceStakeholderUrn,

              "sourceName": state?.growerItem?.sourceName,

              "sourceLocationName": state?.growerItem?.sourceLocationName,

              "sourceLocationAddress": state?.growerItem?.sourceLocationAddress,

              "sourceStakeholderPo": state?.growerItem?.sourceStakeholderPo,

              "landId": state?.growerItem?.landId,

              "odometerReading": pickupUpdatedDetails?.odometerReading,

              "isHitInspectionChecklist": pickupUpdatedDetails?.isHitInspectionChecklist,

              // "isProperLashing": pickupUpdatedDetails?.isProperLashing,

              // "isPayloadWithinCapacity": pickupUpdatedDetails?.isPayloadWithinCapacity,

              // "isPayloadLengthExceedLimit": pickupUpdatedDetails?.isPayloadLengthExceedLimit,

              // "isPayloadHeightExceedLimit": pickupUpdatedDetails?.isPayloadHeightExceedLimit,
              "isSingleBundle": false,

              "totalWeight": totalLotDetailsWeight,

              // "totalMoisture": totalLotDetailsMoisture,

              "totalMoisture": avgMoistureLotDetails,

              "containerName": pickupUpdatedDetails?.containerName,

              "nocFileId": nocUploadDOc?.blobResponse?.blobFileName ? nocUploadDOc?.blobResponse?.blobFileName : pickupUpdatedDetails?.nocFileId,

              "nocFileName": nocUploadDOc?.blobResponse?.fileName ? nocUploadDOc?.blobResponse?.fileName : pickupUpdatedDetails?.nocFileName,

              "transitFileName": transitPassUploadDOc?.blobResponse?.fileName ? transitPassUploadDOc?.blobResponse?.fileName : pickupUpdatedDetails?.transitFileName,

              "transitPassFileId": transitPassUploadDOc?.blobResponse?.blobFileName ? transitPassUploadDOc?.blobResponse?.blobFileName : pickupUpdatedDetails?.transitPassFileId,

              "isSourceNotificationSent": state?.growerItem?.isSourceNotificationSent,

              "isSourceNotificationAcklgd": state?.growerItem?.isSourceNotificationAcklgd,

              "leftoverQuantity": state?.growerItem?.leftoverQuantity,

              "isActive": 1,

              "acknowledgementId": state?.growerItem?.acknowledgementId,

              // "createdOn": "2022-12-29T13:59:08.787Z",

              // "createdBy": "7b146c20-1ba0-495f-88c2-5482a124f9c9",      

              // "consignmentPickupRbCbs": !loadingDone ? lotDetailsArrNew : {},
              // "consignmentPickupRbCbs": loadingDone ? lotDetailsArrNew : null,
              "consignmentPickupRbCbs": lotDetails,

              "documents": [
                {
                  "id": null,
                  "documentType": "noc file",
                  "documentName": nocUploadDOc?.blobResponse?.fileName ? nocUploadDOc?.blobResponse?.fileName : pickupUpdatedDetails?.nocFileName,
                  "documentBlobName": nocUploadDOc?.blobResponse?.blobFileName ? nocUploadDOc?.blobResponse?.blobFileName : pickupUpdatedDetails?.nocFileId,
                  "documentContainerName": "pit",
                  "consignmentId": state?.consignmentdetails?.id,
                  "consignmentSourceId": state?.growerItem?.id,

                },
                {
                  "id": null,
                  "documentType": "transitPass file",
                  "documentName": transitPassUploadDOc?.blobResponse?.fileName ? transitPassUploadDOc?.blobResponse?.fileName : pickupUpdatedDetails?.transitFileName,
                  "documentBlobName": transitPassUploadDOc?.blobResponse?.blobFileName ? transitPassUploadDOc?.blobResponse?.blobFileName : pickupUpdatedDetails?.transitPassFileId,
                  "documentContainerName": "pit",
                  "consignmentId": state?.consignmentdetails?.id,
                  "consignmentSourceId": state?.growerItem?.id,

                }
              ]
            }
          ]
        },
        {
          headers: {
            Authorization: 'Bearer ' + getLocalStorageItem('id_token'),
          }
        }, null
      )
      .then((response) => {
        setLotDetailsArrNew([]);
        setPickupDetailsSave(response.data);
      })
      .catch(function (error) {
        setPickupDetailsSave(error);
        toast.error(error.message);
      });
  }

  useEffect(() => {
    if (pickupDetailsSave) {
      if (pickupDetailsSave.isSuccess === true) {
        toast.success(pickupDetailsSave?.message)
        navigate('/ConsignmentPickUp', { state: { consignmentNo: state?.consignmentdetails?.consignmentNo } })
      }
      else {
        toast.error(pickupDetailsSave?.message ? pickupDetailsSave?.message : "Error")
      }
    }
  }, [pickupDetailsSave]);

  const columns = [
    { field: 'bundleId', headerName: 'Bundle ID', width: 180 },
    { field: 'speciesType', headerName: 'Species Type', width: 180 },
    {
      field: 'rbCbWeight', headerName: 'Weight(in MT)', width: 150,
    },
    { field: 'avgMoisture', headerName: 'Average Moisture', width: 140 },
    { field: 'noOfPoles', headerName: 'No of poles', width: 150 },
    { field: 'barcodeNo', headerName: 'Barcode', width: 150 },
  ];

  return (
    <>
      <Container maxWidth="xxl">
        {!PROD && <p style={{ textAlign: "center", fontSize: "2vh" }}>PIT05</p>}
        <Typography variant="h4" sx={{ mb: 2 }}>
          <Fab onClick={() => navigate('/ConsignmentPickUp', { state: { consignmentNo: state?.consignmentdetails?.consignmentNo } })} size="small" aria-label="back" title='Back'>
            <KeyboardArrowLeftRounded />
          </Fab> Pick-Up Details
        </Typography>
        <Card>
          <CardContent>
            <Typography variant="h5" gutterBottom>Lot Details</Typography>
            {lotDetails.length !== 0 ?
              <Box style={{ height: 300, width: '100%' }}>
                {
                  lotDetails &&
                  <DataGrid rows={lotDetails}
                    columns={columns}
                    pageSize={10}
                    getRowId={(row) => row.bundleId}
                    components={{ Toolbar: QuickSearchToolbar }}
                  />
                }
              </Box>
              : <Typography display="flex" justifyContent='center'>{NO_DATA_AVAILABLE}</Typography>
            }
            <Typography sx={{color: 'red'}}>{errorMessage?.lotDetailsError}</Typography>
            <Divider sx={{
              width: '105%',
              bgcolor: 'black',
              marginTop: '3vh'
            }} mt={2} />
            
              <Grid container spacing={2} mt={2}>
                <Grid item xs={12}>
                  <Grid container spacing={3}>
                    <Grid item xs={12} lg={4}>
                      <FormControl fullWidth size="small">
                        <InputLabel>Type of Inventory to be picked</InputLabel>
                        <Select label="Type of Inventory to be picked" value={state?.consignmentdetails?.materialType} disabled={true}>
                          <MenuItem value="">Select</MenuItem>
                          <MenuItem value="ChipBamboo">Chip Bamboo</MenuItem>
                          <MenuItem value="RawBamboo">Raw Bamboo</MenuItem>
                        </Select>
                      </FormControl>
                    </Grid>
                    <Grid item xs={12} lg={4}>
                      <TextField fullWidth type="number" onFocus={handleNumberFieldFocus} size="small" label='Total Weight Pick-Up(in MT)' name="totalWeight" value={(totalLotDetailsWeight).toFixed(2)} disabled={true} />
                    </Grid>
                    <Grid item xs={12} lg={4}>
                      <TextField fullWidth type="number" onFocus={handleNumberFieldFocus} size="small" label='Average Moisture' name="totalWeight" value={avgMoistureLotDetails} disabled={true} />
                    </Grid>
                    <Grid item xs={12} lg={4}>
                      <TextField fullWidth type="text" size="small" label='Acknowledgement Number' name="acknowledgementId" value={pickupUpdatedDetails?.acknowledgementId} disabled={true} />
                    </Grid>
                    <Grid item xs={12}>
                    <Grid container spacing={2}>
                      {consignmentsource?.[0].invoiceNo ?
                        <Grid item xs={12} lg={6} mt={2}>
                          <Typography variant="body1">Uploaded NOC From Village Head</Typography>
                          <label style={{ color: "blue" }}>{pickupUpdatedDetails?.nocFileName}</label>
                          {consignmentsource?.[0]?.nocFileId ? <input className="view-file-link-btn" type="button" value="View Document" onClick={(e) => viewAndDownloadDocument(e, consignmentsource?.[0]?.nocFileId, consignmentsource?.[0]?.containerName, consignmentsource?.[0]?.nocFileName)} /> : <b>No File Found</b>}
                          <Typography variant="body1">Uploaded Transit pass from Forest Department</Typography>
                          <label style={{ color: "blue" }}>{pickupUpdatedDetails?.transitFileName}</label>
                          {consignmentsource?.[0]?.transitPassFileId ? <input className="view-file-link-btn" type="button" value="View Document" onClick={(e) => viewAndDownloadDocumentForTransit(e, consignmentsource?.[0]?.transitPassFileId, consignmentsource?.[0]?.containerName, consignmentsource?.[0]?.transitFileName)} /> : <b >No File Found</b>}
                        </Grid>
                        :
                        <Grid item xs={12} lg={6} mt={2}>
                          <>
                            <Typography variant="body1">Upload NOC From Village Head</Typography>
                            <label className="chooseFile-create-rateCard">
                              <input style={{ display: "none" }} type="file" accept="image/jpeg, image/jpg, image/png, .pdf" name="nocFileName" onChange={(e) => uploadNocDoc(e)} />Upload File
                              <label className="documentName-create-pickupdetails">{selectedNocFile?.name ? selectedNocFile?.name : pickupUpdatedDetails?.nocFileName}</label>
                              <div className='mandatory_field'>{errorMessage.nocFileIdError}</div>
                              <Typography variant="subtitle2" fontSize="1.8vh" align="left" color="green">(upload only .png, .jpg, .jpeg, .pdf, files.File size limit=5MB)</Typography>
                            </label>
                            <Typography variant="body1">Upload Transit pass from Forest Department</Typography>
                            <label class="chooseFile-create-rateCard">
                              <input style={{ display: "none" }} type="file" name="transitFileName" accept="image/jpeg, image/jpg, image/png, .pdf" onChange={(e) => uploadTransitPassDoc(e)} />Upload File
                              <label className="documentName-create-pickupdetails">{selectedTransitFile?.name ? selectedTransitFile?.name : pickupUpdatedDetails?.transitFileName}</label>
                            </label>
                            <div className='mandatory_field'>{errorMessage.transitPassFileIdError}</div>
                            <Typography variant="subtitle2" fontSize="1.8vh" align="left" color="green">(upload only .png, .jpg, .jpeg, .pdf, files.File size limit=5MB)</Typography>
                          </>
                        </Grid>
                      }
                    </Grid>
                  </Grid>
                  </Grid>
                </Grid>

              </Grid>
              
          </CardContent>
        </Card>
        {console.log("state?.consignmentdetails", state?.consignmentdetails)}
        {!state?.consignmentdetails?.isLoadingDone &&
          <Box display='flex' alignItems="center" justifyContent="center" mt={3} style={{ float: "right" }}>
            <Button variant="contained" sx={{ minWidth: 100, ml: 1 }} onClick={(e) => onLoadingDoneLotDetails(e)}>Complete Loading</Button>
             </Box>
        }
      </Container>
      <ConfirmationPopover onOpen={confirmOpen} onConfirm={onConfirmSave} onClose={handleConfirmClose} action="Save" />
      <ConfirmationPopover onOpen={confirmOpen2} onConfirm={onConfirmComplete} onClose={handleConfirmClose2} action="Complete Loading" />
      <Dialog maxWidth='xs' fullWidth open={logModalOpen}>
        <DialogContent>
          <ConfirmPopover title={pickupDetailsSave?.message} navigate={navigate} gotoConsignmentPickup="gotoConsignmentPickup" />
        </DialogContent>
      </Dialog>
      <Dialog maxWidth='xs' fullWidth open={logModalOpen1}>
        <DialogContent>
          <ErrorPopover title={pickupDetailsSave?.message ? pickupDetailsSave?.message : "Error"} />
        </DialogContent>
        <DialogActions>
          <Button onClick={handleLogModalClose1}>OK</Button>
        </DialogActions>
      </Dialog>
    </>
  )
}
export default PickUpDetails;